import Big from 'big.js'
import { ProductMetadata } from 'indices-list'
import { getPerformance } from 'pages/index-details/utils'
import { GLOBAL_COLORS } from 'theme'
import { marketCapNumber } from 'utils'
import { DailyStatistics } from '../../services/query-v2/products/index/daily-statistics/model'
import { Product } from '../../services/query-v2/products/index/product-info/model'
import { ApyData } from 'services/query-v2/products/apy/model'

export interface GradientTagline {
  regularText: string
  gradientText: string
}

export const getWords = (product: ProductMetadata): GradientTagline => {
  const isCAI = product.symbol === 'cai'
  const isARTX = product.symbol === 'artxai' || product.symbol === 'jmx'
  const words = product.tagLine.split(' ')

  const regularText = words.slice(0, isCAI ? -1 : isARTX ? -2 : -3).join(' ')
  const gradientText = words
    .slice(words.length - (isCAI ? 1 : isARTX ? 2 : 3), words.length)
    .join(' ')

  return { regularText, gradientText }
}

export const getProductCoverInformation = (
  product: Product,
  dailyStats: DailyStatistics,
  apyData: ApyData,
) => {
  const { apy } = apyData
  const performance = getPerformance(product, dailyStats)
  const yearToDateReturns = Big(performance.USD[2])

  const isYTDPositive = yearToDateReturns.gte(0)
  const isAPYPositive = apy.gte(0)
  const showAPY = product.symbol !== 'ARTXAI' && product.symbol !== 'JMX'

  return !showAPY
    ? [
        {
          label: 'Market cap',
          value: marketCapNumber(product.marketCap.toString(), '$'),
        },
        {
          label: 'Price',
          value: `$${dailyStats.currentPrice.round(2, 2).toFixed(2)}`,
        },
        {
          label: 'YTD return',
          value: `${yearToDateReturns}%`,
          color: isYTDPositive ? GLOBAL_COLORS.secondaryGreen : GLOBAL_COLORS.volcanoRed,
        },
      ]
    : [
        {
          label: 'Market cap',
          value: marketCapNumber(product.marketCap.toString(), '$'),
        },
        {
          label: 'Price',
          value: `$${dailyStats.currentPrice.round(2, 2).toFixed(2)}`,
        },
        {
          label: 'APY',
          value: `${apy.round(2, 2).toFixed(2)}%`,
          color: isAPYPositive ? GLOBAL_COLORS.secondaryGreen : GLOBAL_COLORS.volcanoRed,
        },
        {
          label: 'YTD return',
          value: `${yearToDateReturns}%`,
          color: isYTDPositive ? GLOBAL_COLORS.secondaryGreen : GLOBAL_COLORS.volcanoRed,
        },
      ]
}
